import BaseModel from './BaseModel';

/** Class representing a section. */
class Stat extends BaseModel {}

export default Stat;